import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="w-full py-10 md:py-16 px-4 bg-[#FDF6F0] relative overflow-hidden" data-id="element-125">
      <div className="absolute inset-0 bg-glow-purple opacity-40 pointer-events-none" data-id="element-126" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-127">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl lg:text-5xl font-bold mb-5 md:mb-8 text-brand-text-primary" data-id="element-128">
          No Estás Rota.{' '}
          <span className="text-brand-purple-light" data-id="element-129">Estás Desincronizada.</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg md:text-xl text-brand-text-body mb-6 md:mb-10 leading-relaxed space-y-4 md:space-y-6" data-id="element-130">
          <p data-id="element-131">
            Todo el sistema de fitness y nutrición fue diseñado para el ciclo
            hormonal masculino de 24 horas. Tu cuerpo femenino funciona en
            ciclos de 28 días con 4 fases completamente distintas.
          </p>
          <p data-id="element-132">
            Cuando aplicás una estrategia de 24 horas a un cuerpo de 28 días,
            obtenés exactamente lo que estás experimentando: esfuerzo sin
            resultados, fatiga crónica y frustración constante.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#F3E8F0] border-2 border-brand-purple-light p-6 md:p-8 rounded-xl shadow-[0_0_30px_rgba(167,139,202,0.2)] backdrop-blur-sm" data-id="element-133">
          <p className="text-xl md:text-2xl font-bold text-brand-text-primary" data-id="element-134">
            "El cuerpo masculino funciona en 24 horas.{' '}
            <br className="hidden md:block" data-id="element-135" />
            <span className="text-brand-orange" data-id="element-136">El tuyo en 28 días.</span> Ahí
            está todo."
          </p>
        </motion.div>
      </div>
    </section>;
}